import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Spin, Empty } from "antd";
import { useTranslation } from "../../i18n/LanguageContext";
import API_URL from "../../apiBase";
import "./style.css";

const EventDetail = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { t, lang } = useTranslation();
    const [item, setItem] = useState(undefined); // undefined = loading, null = not found
    // Column count for the masonry gallery, responsive to viewport width.
    const [cols, setCols] = useState(
        typeof window !== "undefined" && window.innerWidth <= 560
            ? 1
            : typeof window !== "undefined" && window.innerWidth <= 900
            ? 2
            : 3
    );

    useEffect(() => {
        const calc = () => {
            const w = window.innerWidth;
            setCols(w <= 560 ? 1 : w <= 900 ? 2 : 3);
        };
        window.addEventListener("resize", calc);
        return () => window.removeEventListener("resize", calc);
    }, []);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const res = await fetch(`${API_URL}/api/portfolio/${id}?lang=${lang}`);
                if (!res.ok) throw new Error("not found");
                const data = await res.json();
                if (!cancelled) setItem(data.item || null);
            } catch {
                if (!cancelled) setItem(null);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [id, lang]);

    if (item === undefined) {
        return (
            <div className="main-content-wrapper">
                <div style={{ padding: 80, textAlign: "center", width: "100%" }}>
                    <Spin />
                </div>
            </div>
        );
    }

    if (item === null) {
        return (
            <div className="main-content-wrapper">
                <div className="eventDetail">
                    <button className="eventDetail__back" onClick={() => navigate("/Events")}>
                        ← {t("eventDetail.back")}
                    </button>
                    <Empty description={t("eventDetail.notFound")} />
                </div>
            </div>
        );
    }

    // Cover first, then any extra photos.
    const photos = [item.image, ...(item.images || [])].filter(Boolean);
    // Spread photos round-robin across the columns so every column gets a fair
    // share (no empty last column). Preserves left-to-right reading order.
    const columns = Array.from({ length: cols }, () => []);
    photos.forEach((url, i) => columns[i % cols].push({ url, i }));

    return (
        <div className="main-content-wrapper">
            <div className="eventDetail">
                <button className="eventDetail__back" onClick={() => navigate("/Events")}>
                    ← {t("eventDetail.back")}
                </button>

                {item.title ? <h1 className="eventDetail__title">{item.title}</h1> : null}
                {item.date ? (
                    <div className="eventDetail__date">
                        {new Date(item.date).toLocaleDateString()}
                    </div>
                ) : null}
                {item.description ? (
                    <p className="eventDetail__text">{item.description}</p>
                ) : null}

                <div className="eventDetail__gallery">
                    {columns.map((col, ci) => (
                        <div className="eventDetail__col" key={ci}>
                            {col.map(({ url, i }) => (
                                <img
                                    key={`${url}-${i}`}
                                    className="eventDetail__img"
                                    src={`${url}${url.includes("?") ? "&" : "?"}w=900&auto=format`}
                                    alt={item.title || "Միջոցառում"}
                                    loading="lazy"
                                />
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default EventDetail;
